import { render, staticRenderFns } from "./CompanyBase.vue?vue&type=template&id=bd4e608a&scoped=true"
import script from "./CompanyBase.vue?vue&type=script&lang=js"
export * from "./CompanyBase.vue?vue&type=script&lang=js"
import style0 from "./CompanyBase.vue?vue&type=style&index=0&id=bd4e608a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e608a",
  null
  
)

export default component.exports